import { Box } from '@mui/material';

interface PromoHeaderProps {
    text: string;
}

const PromoHeader = ({ text }: PromoHeaderProps) => (
    <Box
        sx={{
            width: '100%',
            px: 2,
            py: 0.7,
            borderRadius: '999px',
            fontWeight: 900,
            fontSize: { xs: 15, md: 16 },
            lineHeight: 1.3,
            textAlign: 'center',
            color: '#7c2d12',
            background: 'linear-gradient(90deg, #fde68a, #fdba74, #fcd34d)',
            border: '1px solid rgba(217, 119, 6, 0.45)',
            boxShadow: '0 8px 20px rgba(245, 158, 11, 0.28)'
        }}
    >
        {text}
    </Box>
);

export default PromoHeader;
